import * as fromDatatype from '../datatype-library/index';

export interface bl_applet_to_catalog_link_import_file_helper_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    file_import_hdr_guid: fromDatatype.GuidDataFieldInterface;
    link_type: fromDatatype.VarcharDatatypeInterface;
    rank: fromDatatype.VarcharDatatypeInterface;
    catalogue_code: fromDatatype.VarcharDatatypeInterface;
    catalogue_hdr_guid: fromDatatype.GuidDataFieldInterface;
    catalogue_validate_error: fromDatatype.VarcharDatatypeInterface;
    applet_code: fromDatatype.VarcharDatatypeInterface;
    applet_hdr_guid: fromDatatype.GuidDataFieldInterface;
    applet_validate_error: fromDatatype.VarcharDatatypeInterface;
    tenant_code: fromDatatype.VarcharDatatypeInterface;
    tenant_hdr_guid: fromDatatype.GuidDataFieldInterface;
    tenant_validate_error: fromDatatype.VarcharDatatypeInterface;
    edition_code: fromDatatype.VarcharDatatypeInterface;
    edition_pricing_hdr_guid: fromDatatype.GuidDataFieldInterface;
    edition_validate_error: fromDatatype.VarcharDatatypeInterface;
    applet_to_catalog_link_exist_guid: fromDatatype.VarcharDatatypeInterface;
    applet_to_catalog_link_guid: fromDatatype.VarcharDatatypeInterface;
    short_error_message: fromDatatype.TextDatatypeInterface;
    error_stack_trace: fromDatatype.TextDatatypeInterface;
    line_number: fromDatatype.IntegerDatatypeInterface;
    validated: boolean;
    processed: boolean;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_applet_to_catalog_link_import_file_helper_RowClass implements bl_applet_to_catalog_link_import_file_helper_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    file_import_hdr_guid: fromDatatype.GuidDataFieldInterface;
    link_type: fromDatatype.VarcharDatatypeInterface;
    rank: fromDatatype.VarcharDatatypeInterface;
    catalogue_code: fromDatatype.VarcharDatatypeInterface;
    catalogue_hdr_guid: fromDatatype.GuidDataFieldInterface;
    catalogue_validate_error: fromDatatype.VarcharDatatypeInterface;
    applet_code: fromDatatype.VarcharDatatypeInterface;
    applet_hdr_guid: fromDatatype.GuidDataFieldInterface;
    applet_validate_error: fromDatatype.VarcharDatatypeInterface;
    tenant_code: fromDatatype.VarcharDatatypeInterface;
    tenant_hdr_guid: fromDatatype.GuidDataFieldInterface;
    tenant_validate_error: fromDatatype.VarcharDatatypeInterface;
    edition_code: fromDatatype.VarcharDatatypeInterface;
    edition_pricing_hdr_guid: fromDatatype.GuidDataFieldInterface;
    edition_validate_error: fromDatatype.VarcharDatatypeInterface;
    applet_to_catalog_link_exist_guid: fromDatatype.VarcharDatatypeInterface;
    applet_to_catalog_link_guid: fromDatatype.VarcharDatatypeInterface;
    short_error_message: fromDatatype.TextDatatypeInterface;
    error_stack_trace: fromDatatype.TextDatatypeInterface;
    line_number: fromDatatype.IntegerDatatypeInterface;
    validated: boolean;
    processed: boolean;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
}